import { Route, Routes } from 'react-router';

import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminPage } from './pages/AdminPage';
import { ChallengesPage } from './pages/ChallengesPage';
import { ConfirmationsPage } from './pages/ConfirmationsPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { LeagueTablePage } from './pages/LeagueTablePage';
import { LoginPage } from './pages/LoginPage';
import { MatchesPage } from './pages/MatchesPage';
import { NewChallengePage } from './pages/NewChallengePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ProfilePage } from './pages/ProfilePage';
import { RegisterPage } from './pages/RegisterPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { SubmitMatchPage } from './pages/SubmitMatchPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/* Deliberately unauthenticated: people need to read this before signing up. */}
      <Route path="/privacy" element={<PrivacyPage />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<LeagueTablePage />} />
        <Route path="/matches" element={<MatchesPage />} />
        <Route path="/matches/new" element={<SubmitMatchPage />} />
        <Route path="/confirmations" element={<ConfirmationsPage />} />
        <Route path="/challenges" element={<ChallengesPage />} />
        <Route path="/challenges/new" element={<NewChallengePage />} />
        <Route path="/players/:id" element={<ProfilePage />} />
        <Route path="/admin" element={<AdminPage />} />
        {/* Unknown paths land on the home page rather than a dead end. */}
        <Route path="*" element={<LeagueTablePage />} />
      </Route>
    </Routes>
  );
}
